
// Descomentar en entorno de PRODUCCIÓN-IFT

const apiUrls = {
 desencriptar: "https://sniiweb.crt.gob.mx/api/jwt/desencriptar", 
  permisos: "https://sniiweb.crt.gob.mx/api/permisos", 
  geobintWeb:"https://geoweb.crt.gob.mx/geobintWeb", 
  subirArchivos: "https://sniiweb.crt.gob.mx/subirArchivos", 
  consultarArchivos:"https://sniiweb.crt.gob.mx/Archivos",
  logs:"https://sniiweb.crt.gob.mx/log"
  
};


 /*
  // Descomentar en entorno de QA-IFT
  const apiUrls = {
    desencriptar: "https://sniiwebqa.crt.gob.mx/api/jwt/desencriptar",
    permisos: "https://sniiwebqa.crt.gob.mx/api/permisos",
    geobintWeb:"https://geobintwebqa.crt.gob.mx/geobintWeb",
    subirArchivos: "https://sniiwebqa.crt.gob.mx/subirArchivos",
    consultarArchivos:"https://sniiwebqa.crt.gob.mx/Archivos",
    logs:"sniiwebqa.crt.gob.mx/log"
    
  };
 */
   /*

  // Descomentar en entorno de QA-IS
  const apiUrls = {
    desencriptar: "http://192.168.50.100:8980/api/jwt/desencriptar",
    permisos: "http://192.168.50.100:8980/api/permisos",
    geobintWeb:"https://172.17.39.30:8080/geobintWeb",
    subirArchivos: "http://192.168.50.101:8081/subirArchivos",
    consultarArchivos:"http://192.168.50.101:8081/Archivos",
    logs:"http://localhost:5000/log"
    
  };
    */
 
  
 
  export default apiUrls;
